import React, { useState } from 'react';
import LeaderBoardList from './leaderBoardList';
import LeaderBoardTeam from './LeaderBoardTeam';
import { useAccount } from 'wagmi';
import { getMyTeam } from '../../web3/SFM-TeamsUtils';
import JoiningRequests from './joiningRequests';
import { getImageUrlFromJson } from '../../utils/getImageUrlFromJson';

const TabbedPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [myTeam, setMyTeam] = useState();
  const { isConnected, address } = useAccount();

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const getPageContent = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return <LeaderBoardList />;
      case 1:
        return <LeaderBoardTeam />;
      case 2:
        return <JoiningRequests teamId={myTeam && parseInt(myTeam.id)} />;
      default:
        return null;
    }
  };

  const getUserTeam = React.useCallback(async () => {
    try {
      const team = await getMyTeam();
      if (team) {
        let leaderurl = await getImageUrlFromJson(team.leaderURI);
        let memberurl = await getImageUrlFromJson(team.memberURI);
        setMyTeam({ ...team, leaderImage: leaderurl, memberImage: memberurl });
      }
    } catch (e) {
      console.log(e);
      setMyTeam({});
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    isConnected && getUserTeam();
  }, [getUserTeam]);

  return (
    <div className="leaderboard-contianer">
      <div className="tab-buttons">
        <button
          className={`tab-button ${activeTab === 0 ? 'active' : ''}`}
          onClick={() => handleTabClick(0)}
        >
          Individual Leader Board
        </button>
        <button
          className={`tab-button ${activeTab === 1 ? 'active' : ''}`}
          onClick={() => handleTabClick(1)}
        >
          Team Leader Board
        </button>
        {myTeam &&
          Object.keys(myTeam).length !== 0 &&
          myTeam.leader === address &&
          myTeam.requiresApproval && (
            <button
              className={`tab-button ml-4 ${activeTab === 2 ? 'active' : ''}`}
              onClick={() => handleTabClick(2)}
            >
              Members Joining Requests
            </button>
          )}
      </div>
      <div className="tab-content">{getPageContent(activeTab)}</div>
    </div>
  );
};

export default TabbedPage;
